import getCurrentISOString from '@gef-ui/date-fns-utils/getCurrentISOString';
import { getLabelMessage } from '@gef-ui/localization/messages';
import { useVersionInfoLazy } from '@gef-ui/version-info-core';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React, { cloneElement, useMemo, useState } from 'react';
import { errorPropType } from '../../constants';
import { useSendErrorLocal } from '../../hooks';
import { useDefaultComponentValue } from '../../utils';
import { FullSizeActionButtons, RefreshButton, ReportButton } from '../ActionButtons';
import ErrorAlert from '../ErrorAlert';
import ErrorInfo from '../ErrorInfo';
import ErrorMeta from '../ErrorMeta';
const COMPONENT_NAME = 'MuiError';
const Error = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { error, onRefresh, actionButton, withSendOption, versionInfoConfig, hideHeading, sendErrorCallback, ...other } = props;
    const generatedTimestamp = useMemo(()=>getCurrentISOString(), []);
    const { shortDescription, longDescription, heading, traceId, screen, timestamp = generatedTimestamp } = error;
    const [isAlertVisible, setIsAlertVisible] = useState(true);
    const handleAlertClose = ()=>setIsAlertVisible(false);
    const { fe, be } = useVersionInfoLazy(versionInfoConfig);
    const { isError, sendErrorLocal, isSent, isSending } = useSendErrorLocal(sendErrorCallback);
    return /*#__PURE__*/ React.createElement(Box, other, !hideHeading && /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            mb: 2
        },
        variant: "h5"
    }, `${getLabelMessage('common:error').toUpperCase()}: ${heading}`), /*#__PURE__*/ React.createElement(ErrorInfo, {
        shortDescription: shortDescription,
        longDescription: longDescription
    }), /*#__PURE__*/ React.createElement(FullSizeActionButtons, null, /*#__PURE__*/ React.createElement(ReportButton, {
        withSendOption: withSendOption,
        onSend: ()=>sendErrorLocal(fe, be, error, timestamp),
        isSent: isSent,
        fe: fe,
        be: be,
        error: error,
        timestamp: timestamp,
        fullSize: !onRefresh,
        isSending: isSending
    }), onRefresh && /*#__PURE__*/ React.createElement(RefreshButton, {
        onClick: onRefresh,
        sx: (theme)=>({
                [theme.breakpoints.up('md')]: {
                    margin: theme.spacing(0, 'auto', 0, 2)
                }
            })
    }), actionButton && /*#__PURE__*/ cloneElement(actionButton, {
        error
    })), isSent && isAlertVisible && /*#__PURE__*/ React.createElement(ErrorAlert, {
        onClose: handleAlertClose,
        isError: isError,
        error: error,
        fe: fe,
        be: be,
        timestamp: timestamp,
        sx: {
            mb: 3
        }
    }), /*#__PURE__*/ React.createElement(ErrorMeta, {
        screen: screen,
        traceId: traceId,
        fe: fe,
        be: be,
        timestamp: timestamp
    }));
};
Error.propTypes = {
    actionButton: PropTypes.node,
    error: errorPropType,
    hideHeading: PropTypes.bool,
    onRefresh: PropTypes.func,
    /**
	 * Custom callback for sending errors to BE called with HTTP body
	 */ sendErrorCallback: PropTypes.func,
    versionInfoConfig: PropTypes.object,
    withSendOption: PropTypes.bool
};
export default Error;
